import { makeBaseSvgIconProps } from './_utils/makeBaseSvgIconProps'

export const IconGateway = () => {
  return (
    <svg {...makeBaseSvgIconProps('0 0 30 30')}>
      <path d="M0 0 30 0 30 30 0 30z" fill="currentColor" />
    </svg>
  )
}
